const breadCrumb = "Lotação de Servidores - Carga Horária";

const routes = [
  {
    path: "/atribuicao-carga-horaria-professor",
    name: "atribuicao-carga-horaria-professor",
    meta: {
      allowedPermissions: ["carga_horaria_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/AtribuicaoCargaHorariaProfessor/AtribuicaoCargaHorariaProfessorHome.vue"
      ),
  },
  {
    path: "/atribuicao-carga-horaria-professor/vincular/:id",
    name: "atribuicao-carga-horaria-professor-vincular",
    meta: {
      allowedPermissions: ["carga_horaria_vincular"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/AtribuicaoCargaHorariaProfessor/AtribuicaoCargaHorariaProfessorVincular.vue"
      ),
  },
  {
    path: "/atribuicao-carga-horaria-professor/desvincular/:id",
    name: "atribuicao-carga-horaria-professor-desvincular",
    meta: {
      allowedPermissions: ["carga_horaria_desvincular"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CargaHoraria/AtribuicaoCargaHorariaProfessor/AtribuicaoCargaHorariaProfessorDesvincular.vue"
      ),
  },
];

export default routes;
